import i18n from '../i18n'

const onlyHttps = /^https:\/\//i
const hasImageExtension = /\.(gif|jpg|jpeg|tiff|png)$/i
const checkWholeURL = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/i

const actionValidations = new Map(
  [
    [
      'title',
      {
        // Cannot be empty
        identifier: 'title',
        rules: [
          { type: 'empty', prompt: i18n.t('validations.cannotBeEmpty', { item: `${i18n.tc('action', 1)} ${i18n.t('validations.title')}` }) }
        ]
      }
    ],
    // NOTE: Not used in Migraine Care 2.0
    // [
    //   'reminder-title',
    //   {
    //     // Cannot be empty
    //     identifier: 'reminder-title',
    //     rules: [
    //       { type: 'empty', prompt: i18n.t('validations.cannotBeEmpty', { item: `${i18n.t('reminder')} ${i18n.t('validations.title')}` }) },
    //       { type: 'maxLength[255]', prompt: i18n.t('validations.atMost255') }
    //     ]
    //   }
    // ],
    // [
    //   'reminder-body',
    //   {
    //     // Cannot be empty
    //     identifier: 'reminder-body',
    //     rules: [
    //       { type: 'empty', prompt: i18n.t('validations.cannotBeEmpty', { item: `${i18n.t('reminder')} ${i18n.t('validations.description')}` }) },
    //       { type: 'maxLength[255]', prompt: i18n.t('validations.atMost255') }
    //     ]
    //   }
    // ],
    [
      'short-name',
      {
        // Cannot be empty
        identifier: 'short-name',
        rules: [
          { type: 'empty', prompt: i18n.t('validations.cannotBeEmpty', { item: i18n.t('shortName') }) }
        ]
      }
    ],
    [
      'start-day',
      {
        // Must not be negative and less than `end-day`
        identifier: 'start-day',
        rules: [
          // For the relevant rule to show, do not change the order of the `rules` array
          { type: 'not[-0]', prompt: i18n.t('validations.validPositiveWholeNumber') },
          { type: 'doesntContain[-]', prompt: i18n.t('validations.cannotBeNegative', { day: i18n.t('startDay') }) },
          { type: 'not[0]', prompt: i18n.t('validations.cannotBeZero', { day: i18n.t('startDay') }) },
          { type: 'integer', prompt: i18n.t('validations.positiveWholeNumber', { day: i18n.t('startDay') }) },
          { type: 'integer[1..300]', prompt: i18n.t('validations.between1And300', { day: i18n.t('startDay') }) }
        ]
      }
    ],
    [
      'end-day',
      {
        identifier: 'end-day',
        rules: [
          // For the relevant rule to show, do not change the order of the `rules` array
          { type: 'not[-0]', prompt: i18n.t('validations.validPositiveWholeNumber') },
          { type: 'doesntContain[-]', prompt: i18n.t('validations.cannotBeNegative', { day: i18n.t('endDay') }) },
          { type: 'not[0]', prompt: i18n.t('validations.cannotBeZero', { day: i18n.t('endDay') }) },
          { type: 'integer', prompt: i18n.t('validations.positiveWholeNumber', { day: i18n.t('endDay') }) },
          { type: 'integer[1..300]', prompt: i18n.t('validations.between1And300', { day: i18n.t('endDay') }) },
          { type: 'endDayAfterStartDay', prompt: i18n.t('validations.endDayAfterStartDay') }
        ]
      }
    ]
  ]
)
const lessonValidations = new Map(
  [
    [
      'title',
      {
        // Cannot be empty
        identifier: 'title',
        rules: [
          { type: 'empty', prompt: i18n.t('validations.cannotBeEmpty', { item: `${i18n.tc('lesson', 1)} ${i18n.t('validations.title')}` }) },
          { type: 'maxLength[255]', prompt: i18n.t('validations.atMost255') }
        ]
      }
    ],
    [
      'image-link',
      {
        identifier: 'image-link',
        optional: true,
        rules: [
          { type: 'regExp', value: onlyHttps, prompt: i18n.t('validations.httpsImageLink') },
          { type: 'regExp', value: hasImageExtension, prompt: i18n.t('validations.acceptedImageTypes') },
          { type: 'regExp', value: checkWholeURL, prompt: i18n.t('validations.validLink') }
        ]
      }
    ],
    [
      'primary-text',
      {
        identifier: 'primary-text',
        depends: 'primary-link',
        rules: [
          { type: 'empty', prompt: i18n.t('validations.noEmptyButtonLabel') }
        ]
      }
    ],
    [
      'secondary-text',
      {
        identifier: 'secondary-text',
        depends: 'secondary-link',
        rules: [
          { type: 'empty', prompt: i18n.t('validations.noEmptyButtonLabel') }
        ]
      }
    ],
    [
      'primary-link',
      {
        identifier: 'primary-link',
        depends: 'primary-text',
        rules: [
          { type: 'empty', prompt: i18n.t('validations.noEmptyLink') },
          { type: 'regExp', value: onlyHttps, prompt: i18n.t('validations.httpsResourceLink') },
          { type: 'regExp', value: checkWholeURL, prompt: i18n.t('validations.validLink') }
        ]
      }
    ],
    [
      'secondary-link',
      {
        identifier: 'secondary-link',
        depends: 'secondary-text',
        rules: [
          { type: 'empty', prompt: i18n.t('validations.noEmptyLink') },
          { type: 'regExp', value: onlyHttps, prompt: i18n.t('validations.httpsResourceLink') },
          { type: 'regExp', value: checkWholeURL, prompt: i18n.t('validations.validLink') }
        ]
      }
    ],
    [
      'short-name',
      {
        // Cannot be empty
        identifier: 'short-name',
        rules: [
          { type: 'empty', prompt: i18n.t('validations.cannotBeEmpty', { item: i18n.t('shortName') }) }
        ]
      }
    ],
    [
      'start-day',
      {
        // Must not be negative and less than `end-day`
        identifier: 'start-day',
        rules: [
          { type: 'not[-0]', prompt: i18n.t('validations.validPositiveWholeNumber') },
          { type: 'doesntContain[-]', prompt: i18n.t('validations.cannotBeNegative', { day: i18n.t('startDay') }) },
          { type: 'not[0]', prompt: i18n.t('validations.cannotBeZero', { day: i18n.t('startDay') }) },
          { type: 'integer', prompt: i18n.t('validations.positiveWholeNumber', { day: i18n.t('startDay') }) },
          { type: 'integer[1..300]', prompt: i18n.t('validations.between1And300', { day: i18n.t('startDay') }) }
        ]
      }
    ]
  ]
)

const validations = new Map(
  [
    ['action', actionValidations],
    ['lesson', lessonValidations]
  ]
)

const actionModalFields = ['title', 'start-day', 'end-day']
const lessonModalFields = ['title', 'start-day']

const getValidations = (contentType, fields = [], validationsMap = validations) => {
  return Object.fromEntries(
    fields.length
      ? fields.map(field => [field, validationsMap.get(contentType).get(field)])
      : validationsMap.get(contentType)
  )
}

const actionValidationConfigurations = new Map(
  [
    ['form', getValidations('action')],
    ['modal', getValidations('action', actionModalFields)]
  ]
)

const lessonValidationConfigurations = new Map(
  [
    ['form', getValidations('lesson')],
    ['modal', getValidations('lesson', lessonModalFields)]
  ]
)

const fields = new Map(
  [
    ['action', actionValidationConfigurations],
    ['lesson', lessonValidationConfigurations]
  ]
)

const constructConfiguration = (contentType, formType, fieldsMap = fields) => {
  return {
    fields: fieldsMap.get(contentType).get(formType),
    inline: true
  }
}

const constructValidationInitializer = (jQuery, elementId, contentType, formType) => {
  return () => jQuery(`#${elementId}`).form(constructConfiguration(contentType, formType))
}

export const constructValidator = (jQuery, elementId, contentType, formType, constructCustomValidationSetters = () => () => {}) => {
  const setCustomValidations = constructCustomValidationSetters(jQuery)
  const validationInitializer = constructValidationInitializer(jQuery, elementId, contentType, formType)

  return () => {
    setCustomValidations()
    validationInitializer()
  }
}
